

export const StepBar = ({formState, totalPages})  => {

    return (
        <div>
            <div className="stepper-wrapper">
                {
                    formState === 1 ?
                    <>
                    {completedMark()}
                    {activeMark()}
                    {activeMark()}
                    </>
                    : (
                        formState === 2 ?
                        <>
                        {completedMark()}
                        {completedMark()}
                        {activeMark()}
                        </>
                        : <>
                        {completedMark()}
                        {completedMark()}
                        {completedMark()}
                        </> 
                    )
                }
            </div>
        </div>
    );
}

const activeMark = () => {
    return(
        <div className="stepper-item active">
        <div className="step-counter">
        <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_105_21)">
            <mask id="mask0_105_21" maskUnits="userSpaceOnUse" x="0" y="0" width="92" height="92">
            <path d="M0 -3.20376e-06H92V92H0V-3.20376e-06Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_105_21)">
            <path d="M33.1584 35.8609L1.73309 2.5176C2.54672 6.28661 5.6877 20.4615 10.1259 35.8609H33.1584Z" fill="#E9F4EE"/>
            <path d="M35.8493 10.1371C20.4502 5.69865 6.27558 2.55766 2.50647 1.74404L35.8493 33.1689V10.1371Z" fill="#E9F4EE"/>
            <path d="M68.3391 63.6686L82.4068 76.8743C93.7486 62.7685 92.8795 42.0894 79.788 28.9987C77.3198 26.5306 73.2927 24.0806 68.3391 21.719V63.6686Z" fill="#E9F4EE"/>
            <path d="M63.2457 19.4498C56.5217 16.6377 48.7071 13.9925 40.9427 11.6418V37.9501L63.2457 58.887V19.4498Z" fill="#E9F4EE"/>
            <path d="M37.9397 40.9545L11.6302 40.954C13.9811 48.7181 16.626 56.5324 19.4379 63.2567L58.8759 63.2582L37.9397 40.9545Z" fill="#E9F4EE"/>
            <path d="M63.6572 68.3514L21.7073 68.3499C24.069 73.3043 26.5187 77.3314 28.9871 79.8C42.078 92.8907 62.757 93.7606 76.8625 82.4184L63.6572 68.3514Z" fill="#E9F4EE"/>
            </g>
            </g>
            <defs>
            <clipPath id="clip0_105_21">
            <rect width="92" height="92" fill="white"/>
            </clipPath>
            </defs>
            </svg>

        </div>
    </div>
    )
}

const completedMark = () => {
    return(
        <div className="stepper-item completed">
        <div className="step-counter">
        <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_105_2)">
            <mask id="mask0_105_2" maskUnits="userSpaceOnUse" x="0" y="0" width="92" height="92">
            <path d="M0 -3.20376e-06H92V92H0V-3.20376e-06Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_105_2)">
            <path d="M33.1584 35.8609L1.73315 2.5176C2.54678 6.28661 5.68776 20.4615 10.1259 35.8609H33.1584Z" fill="#25D36B"/>
            <path d="M35.8494 10.1371C20.4503 5.69865 6.2757 2.55766 2.50659 1.74404L35.8494 33.1689V10.1371Z" fill="#25D36B"/>
            <path d="M68.3391 63.6686L82.4069 76.8743C93.7487 62.7685 92.8795 42.0894 79.7881 28.9987C77.3198 26.5306 73.2928 24.0806 68.3391 21.719V63.6686Z" fill="#25D36B"/>
            <path d="M63.2458 19.4498C56.5217 16.6377 48.7071 13.9925 40.9427 11.6418V37.9501L63.2458 58.887V19.4498Z" fill="#25D36B"/>
            <path d="M37.9397 40.9546L11.6302 40.9541C13.9811 48.7182 16.626 56.5324 19.4379 63.2567L58.8759 63.2582L37.9397 40.9546Z" fill="#25D36B"/>
            <path d="M63.6573 68.3514L21.7073 68.3499C24.0691 73.3043 26.5188 77.3314 28.9871 79.8C42.078 92.8907 62.7571 93.7606 76.8625 82.4184L63.6573 68.3514Z" fill="#25D36B"/>
            </g>
            </g>
            <defs>
            <clipPath id="clip0_105_2">
            <rect width="92" height="92" fill="white"/>
            </clipPath>
            </defs>
            </svg>
        </div>
    </div>
    )
}